import localScaleManager from "../../../../helpers/LocalScaleManager";
import { Helpers } from "../../../../helpers/helpers";

export default class Card extends Phaser.GameObjects.Image {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param depth {number}
   */
  constructor(scene, table, depth = 0) {
    super(scene, 0, 0, Helpers.getCardsSpriteSheet());
    this.scene = scene;
    this.table = table;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);

    this.setDepth(10).setVisible(false);
    this.upsideDown = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "back-card-red")
      .setDepth(this.depth + depth)
      .setVisible(false);
    this.table.poolArray.push(this.upsideDown);

    // this.overlay = this.scene.add
    //   .image(0, 0, this.scene.atlasTexture, "card-overlay")
    //   .setDepth(10)
    //   .setVisible(false);
    // this.table.poolArray.push(this.overlay);

    this.isDealing = false;
    this.beforeWinY = undefined;
    this.beforeWinX = undefined;
    this.code = "";
  }
  visibilityControls(visibility) {
    if (visibility && this.isDealing === false) {
      if (this.upsideDown.x !== this.upsideDown.getData("arrangedX"))
        this.upsideDown.x = this.upsideDown.getData("arrangedX");
      if (this.upsideDown.y !== this.upsideDown.getData("arrangedY"))
        this.upsideDown.y = this.upsideDown.getData("arrangedY");
      if (this.upsideDown.scale !== this.upsideDown.getData("arrangedScale"))
        this.upsideDown.scale = this.upsideDown.getData("arrangedScale");
    }
    if (this.upsideDown.visible !== visibility)
      this.upsideDown.setVisible(visibility);
    // if (!visibility) {
    //   if (this.overlay.visible) this.overlay.setVisible(false);
    // }
    // this.upsideDown.setDepth(1);
  }
  updateTexture(code, kickerCard) {
    const cardsTexture = Helpers.getCardsSpriteSheet();
    const newTexture = kickerCard ? cardsTexture + "-kicker" : cardsTexture;
    const newFrame = Helpers.getCardsFrameByCode(code);
    if (this.texture.key !== newTexture || this.frame.name !== newFrame) {
      this.setTexture(newTexture, newFrame);
    }
    this.code = code;
  }
  showCardOverlay() {
    if (!this.code) return;
    this.updateTexture(this.code, true);
  }
  hideCardOverlay() {
    if (!this.code) return;
    this.updateTexture(this.code, false);
  }
  scaleControls(cardSize) {
    localScaleManager.scaleSprite(this, cardSize, cardSize, 0, 1, true);
    // localScaleManager.scaleSpriteTo(this, cardScale);
    // localScaleManager.scaleSpriteTo(this.overlay, cardScale);
    localScaleManager.scaleSprite(
      this.upsideDown,
      cardSize / 1.2,
      cardSize / 1.2,
      0,
      1,
      true
    );
    // localScaleManager.scaleSpriteTo(this.upsideDown, cardBackScale);
  }
  positionControls() {
    // this.overlay.setPosition(this.x, this.y);
    this.upsideDown.setPosition(this.x, this.y);
    this.upsideDown.setData("initX", this.upsideDown.x);
    this.upsideDown.setData("initY", this.upsideDown.y);
    this.upsideDown.setData("initScale", this.upsideDown.scale);
    this.upsideDown.setData("arrangedY", this.upsideDown.y);
    this.upsideDown.setData("arrangedX", this.upsideDown.x);
  }
  reposition() {
    // this.overlay.setPosition(this.x, this.y);
    this.upsideDown.setPosition(this.x, this.y);
    this.upsideDown.setData("initX", this.upsideDown.x);
    this.upsideDown.setData("initY", this.upsideDown.y);
    this.upsideDown.setData("arrangedY", this.upsideDown.y);
    this.upsideDown.setData("arrangedX", this.upsideDown.x);
  }
}
